import { render, staticRenderFns } from "./OriginatorRulesFilter.vue?vue&type=template&id=b9477b38&"
import script from "./OriginatorRulesFilter.vue?vue&type=script&lang=ts&"
export * from "./OriginatorRulesFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports